import { getToken } from "../../utils/auth";

const API_ROOT = "/api/crm-postventa-v2";

const withTokenHeader = (token) => ({
  "Content-Type": "application/json",
  "X-CRM-Token": token || getToken() || "",
});

const handleResponse = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.mensaje || payload?.message || "No se pudo completar la operación.");
    error.status = response.status;
    throw error;
  }

  return payload;
};

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
};

const postJson = async (path, body) => {
  const token = getToken() || "";
  const response = await fetch(`${API_ROOT}${path}`, {
    method: "POST",
    headers: withTokenHeader(token),
    body: JSON.stringify({
      token,
      ...body,
    }),
  });

  return handleResponse(response);
};

const getJson = async (path, params) => {
  const token = getToken() || "";
  const response = await fetch(`${API_ROOT}${path}${buildQuery(params)}`, {
    method: "GET",
    headers: withTokenHeader(token),
  });

  return handleResponse(response);
};

export const crmPostventaV2Api = {
  obtenerResumenAlertas: async ({ fechaReferencia } = {}) => getJson(`/alertas/resumen`, { fechaReferencia }),
  obtenerAlertas: async (params = {}) => getJson(`/alertas`, params),
  obtenerContadorAlertas: async ({ fechaReferencia } = {}) => getJson(`/alertas/contador`, { fechaReferencia }),
  obtenerCola: async (slug, { fecha } = {}) => getJson(`/${slug}/cola`, { fecha }),
  obtenerDetalle: async (slug, id) => getJson(`/${slug}/${id}`),
  obtenerHistorial: async (slug, id) => getJson(`/${slug}/${id}/historial`),
  ejecutarAccion: async (slug, id, body) => postJson(`/${slug}/${id}/acciones`, body),
  generar: async (slug, { dryRun = true, fecha } = {}) =>
    postJson(`/${slug}/generar`, {
      dryRun,
      fechaReferencia: fecha,
    }),
  reconciliar: async (slug, { dryRun = true, fecha } = {}) =>
    postJson(`/${slug}/reconciliar`, {
      dryRun,
      fechaReferencia: fecha,
    }),
  previsualizarCierreMasivoZocoCheck: async ({ periodo } = {}) =>
    postJson(`/zoco-check/cierre-masivo/preview`, { periodo }),
  cerrarMasivamenteZocoCheck: async ({ periodo, procesoIdsPreview = [] } = {}) =>
    postJson(`/zoco-check/cierre-masivo`, {
      periodo,
      confirmar: true,
      procesoIdsPreview,
    }),
  obtenerEstadoAutomatizacion: async () => getJson(`/automatizacion/estado`),
  ejecutarAutomatizacion: async ({ procesoCodigo, dryRun = true, fechaReferencia } = {}) =>
    postJson(`/automatizacion/ejecutar`, {
      procesoCodigo,
      dryRun,
      fechaReferencia,
    }),
  tomarProceso: async (procesoId, body = {}) => postJson(`/procesos/${procesoId}/tomar`, body),
  asignarProceso: async (procesoId, body = {}) => postJson(`/procesos/${procesoId}/asignar`, body),
  liberarProceso: async (procesoId, body = {}) => postJson(`/procesos/${procesoId}/liberar`, body),
  subirEvidencia: async (procesoId, body) => postJson(`/procesos/${procesoId}/evidencias`, body),
  obtenerEvidencias: async (procesoId) => getJson(`/procesos/${procesoId}/evidencias`),
  descargarEvidenciaUrl: (id) => `${API_ROOT}/evidencias/${id}/descargar`,
};
